export default __webpack_public_path__ + "static/media/api.a9634b75.svg";